import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import KurortInfoPlate from 'components/kurort/kurortInfoPlate';

const $selections = document.querySelectorAll('.js-selectionsBlock');

if ($selections.length > 0) {
    $selections.forEach(($swiper) => {
        const $list = $swiper.querySelector('.Selections__list');
        const count = +$swiper.getAttribute('data-item-count') || 4;

        new Swiper($list, {
            slidesPerView: count,
            spaceBetween: 20,
            speed: 300,
            loop: false,
            navigation: {
                prevEl: $swiper.querySelector('.js-swiperArrowPrev'),
                nextEl: $swiper.querySelector('.js-swiperArrowNext'),
            },
            modules: [Navigation],
        });
    });
}

const $publicationHeadings = document.querySelector('.js-publication-headings');
$publicationHeadings.addEventListener('click', (event) => {
    if (event.target.tagName === 'A') {
        event.preventDefault();

        const href = event.target.getAttribute('href');
        const heading = document.querySelector(`${href}`);

        const topOffset = window.pageYOffset + heading.getBoundingClientRect().top - 120;

        window.scroll({
            top: topOffset,
            behavior: 'smooth'
        });
    }
});

const $blogArticle = document.querySelector('.js-blogArticle');
if ($blogArticle) {
    const kurortInfoPlate = new KurortInfoPlate({
        container: '.js-blogArticle',
    });

    const $texts = document.querySelectorAll('.Text');
    const $support = kurortInfoPlate.create('miniSupport');
    if ($support && $texts.length) {
        $blogArticle.insertBefore($support, $texts[1]);
    }
}

function pageView() {
    let formData = new FormData();
        formData.append('blog_id', location.href.replace(/[^0-9]/g, ''));

    fetch('/blog/increment_view_counter/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    }).then(response => response.json());
}

pageView();
